import { css as v, LitElement as g, html as a } from "lit";
import { defineCustomElement as u } from "@justeattakeaway/pie-webc-core";
import { property as l, query as d } from "lit/decorators.js";
import { g as p } from "./configs.58b0302e.js";
var f = Object.defineProperty, m = Object.getOwnPropertyDescriptor, h = (c, i, t, s) => {
  for (var e = s > 1 ? void 0 : s ? m(i, t) : i, o = c.length - 1, n; o >= 0; o--)
    (n = c[o]) && (e = (s ? n(i, t, e) : n(e)) || e);
  return s && e && f(i, t, e), e;
};
const w = "icon-check";
class r extends g {
  constructor() {
    super(...arguments), this.size = "xs", this.class = "c-pieIcon c-pieIcon--check";
  }
  connectedCallback() {
    var i, t, s;
    if (super.connectedCallback(), ((i = this._svg) == null ? void 0 : i.getAttribute("width")) === null) {
      const e = p("c-pieIcon c-pieIcon--check", "", null, "IconCheck");
      (t = this._svg) == null || t.setAttribute("width", e.width), (s = this._svg) == null || s.setAttribute("height", e.height);
    }
  }
  updated(i) {
    var s, e;
    let t;
    i.has("size") && (t = p("c-pieIcon c-pieIcon--check", "", this.size, "IconCheck"), (s = this._svg) == null || s.setAttribute("width", t.width), (e = this._svg) == null || e.setAttribute("height", t.height));
  }
  render() {
    return a`<svg xmlns="http://www.w3.org/2000/svg" role="presentation" focusable="false" fill="currentColor" viewBox="0 0 16 16" class="c-pieIcon c-pieIcon--check"><path d="M5.865 12.489a1.217 1.217 0 0 1-.875-.385L1.875 8.656l.98-.875 3.028 3.369 7.253-7.822.963.875-7.35 7.875a1.216 1.216 0 0 1-.875.385l-.009.026Z"></path></svg>`;
  }
}
r.styles = v`
        :host svg {
            display: var(--icon-display-override);
            width: var(--icon-size-override);
            height: var(--icon-size-override);
        }
    `;
h([
  l({ type: String, reflect: !0 })
], r.prototype, "size", 2);
h([
  l({ type: String, reflect: !0 })
], r.prototype, "class", 2);
h([
  d("svg")
], r.prototype, "_svg", 2);
u(w, r);
export {
  r as IconCheck
};
